import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PointsAndDiamondsDialog from './PointsAndDiamondsDialog';
import { ReactComponent as PointsAndDiamondsIcon } from '@/img/reservation_page/points_and_diamonds.svg';

const PointsAndDiamondsBanner = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(true);
    }

    const handleCloseDialog = () => {
        setIsOpen(false);
    }

    return (
        <>
            <div className="points-and-diamonds-banner">
                <div className="points-and-diamonds-banner__content">
                    <div className="points-and-diamonds-banner__info">
                        <div className="points-and-diamonds-banner__icon">
                            <PointsAndDiamondsIcon />
                        </div>
                        <div>
                            {t('GuestWillAccumulatePointsAndDiamonds')}
                            <br />
                            <button className="points-and-diamonds-banner__button" onClick={handleClick}>
                                {t('HowManyPointsAndDiamondsWillIEarn')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {isOpen && <PointsAndDiamondsDialog open={isOpen} onClose={handleCloseDialog} />}
        </>
    );
}

export default PointsAndDiamondsBanner